export default "__VITE_ASSET__jlZlGUHB__"